// src/lib/analytics.ts
import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';

// Fallback gtag per PWA/web (opzionale se usi anche la versione web)
declare global {
  interface Window { gtag?: (...args: any[]) => void }
}

const isNativeAndroid = Capacitor.getPlatform() === 'android';

export async function analyticsInit() {
  try {
    // abilita raccolta (potrai condizionarla al consenso GDPR)
    await FirebaseAnalytics.setEnabled({ enabled: true });
  } catch {}
}

export async function logEvent(name: string, params?: Record<string, any>) {
  try {
    if (isNativeAndroid) {
      await FirebaseAnalytics.logEvent({ name, params: params ?? {} });
    } else if (window.gtag) {
      window.gtag('event', name, params ?? {});
    }
  } catch {}
}

export async function setScreen(screenName: string) {
  try {
    if (isNativeAndroid) {
      await FirebaseAnalytics.setCurrentScreen({ screenName });
    } else if (window.gtag) {
      window.gtag('event', 'screen_view', { screen_name: screenName });
    }
  } catch {}
}

// Esempio: chiamalo nel bootstrap dell'app
export async function trackAppOpen() {
  await logEvent('app_open');
}
